import { render, staticRenderFns } from "./SurveyHome.vue?vue&type=template&id=45b573c0&scoped=true&"
import script from "./SurveyHome.vue?vue&type=script&lang=js&"
export * from "./SurveyHome.vue?vue&type=script&lang=js&"
import style0 from "./SurveyHome.vue?vue&type=style&index=0&id=45b573c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b573c0",
  null
  
)

export default component.exports